import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import { withTranslation } from 'react-i18next';
import {
  actions as ordersActions,
  selectors as ordersSelectors,
} from 'state/orders';

import DateField from 'components/orders/Filters/Filters/Dates/DateField/component';

const getValueByType = {
  first_pickup_time: (state) => ordersSelectors.getFilterFirstPickupTime(state),
  last_dropoff_time: (state) => ordersSelectors.getFilterLastDropoffTime(state),
};

const getMinValue = {
  first_pickup_time: () => undefined,
  last_dropoff_time: (state) =>
    ordersSelectors.getFilterFirstPickupTime(state) &&
    new Date(ordersSelectors.getFilterFirstPickupTime(state)),
};

const getMaxValue = {
  first_pickup_time: (state) =>
    ordersSelectors.getFilterLastDropoffTime(state) &&
    new Date(ordersSelectors.getFilterLastDropoffTime(state)),
  last_dropoff_time: () => undefined,
};

const enhance = compose(
  withTranslation('Orders'),
  connect(
    (state, { type }) => ({
      pathname: state.router.location.pathname,
      minDate: getMinValue[type](state),
      maxDate: getMaxValue[type](state),
      value: getValueByType[type](state),
    }),
    {
      setDateFilter: ordersActions.setDateFilter,
      clearDateFilter: ordersActions.clearDateFilter,
    }
  ),
  withHandlers(() => {
    let responsiveModalRef = React.createRef();
    return {
      responsiveModalRef: () => (ref) => {
        responsiveModalRef = ref;
      },
      handleChange:
        ({ setDateFilter, pathname, type, minDate, maxDate }) =>
        (value, _, e) => {
          e.stopPropagation();
          e.preventDefault();

          if (+minDate > +value || +maxDate < +value) return;
          try {
            const date = value.toISOString().split('T')[0];
            setDateFilter({ type, pathname, value: date });
            responsiveModalRef.close();
          } catch (err) {
            console.error('ERROR', err);
          }
        },

      handleClear:
        ({ clearDateFilter, pathname, type }) =>
        (e) => {
          clearDateFilter({ type, pathname });
          e.stopPropagation();
        },
    };
  })
);

export default enhance(DateField);
